<fc-article-header [content]="content" [analyticsMode]="analyticsMode">
    <div [ngClass]="content.accentTheme">
        <fc-article-sidebyside 
            *ngFor="let c of content.components" 
            [tagDisplay]="content.tagDisplay" 
            [theme]="'basic'"
            [article]="c" [analyticsMode]="analyticsMode">
        </fc-article-sidebyside>
    </div>
</fc-article-header>